import { EditedTask } from "@/types";
import { Dispatch, MutableRefObject, SetStateAction, useCallback } from "react";

const useDoubleClick = (
  taskID: number,
  clickTimeout: NodeJS.Timeout | null,
  isEditing: boolean,
  editedTaskRef: MutableRefObject<EditedTask | null>,
  saveAllowed: MutableRefObject<boolean>,
  setIsEditing: Dispatch<SetStateAction<boolean>>,
  setSelectedEditableTask: Dispatch<SetStateAction<EditedTask | null>>,
  openTaskDetails: (taskID: number) => void,
  handleSave: (editedTask: EditedTask) => Promise<void>
) => {
  const handleDoubleClick = useCallback(async () => {
    if (clickTimeout) {
      clearTimeout(clickTimeout);
    }
    // Save the task if allowed & if the task is the same as the edited task
    if (
      isEditing &&
      saveAllowed.current === true &&
      editedTaskRef.current &&
      taskID === editedTaskRef.current.id
    ) {
      await handleSave(editedTaskRef.current);
    }
    // Set single click states to false
    setIsEditing(false);
    setSelectedEditableTask(null);
    openTaskDetails(taskID);
  }, [
    clickTimeout,
    isEditing,
    setIsEditing,
    setSelectedEditableTask,
    openTaskDetails,
    editedTaskRef,
    taskID,
    saveAllowed,
    handleSave,
  ]);

  return { handleDoubleClick };
};

export default useDoubleClick;
